<template>

    <v-app dark>

        <v-content>

        <router-view name="headertop"></router-view>

            <transition name="fade" mode="out-in">

                <keep-alive :include="['Home', 'Promotion']">

                    <router-view v-if="$route.meta.keepAlive"></router-view>

                    <router-view v-else></router-view>

                </keep-alive>

            </transition>

            <snackbar :color="appcolor" :icon="appicon" :text="appmessage" :show="showsnackbar" @update-snackbar="showsnackbar = false"/>

            <vue-snotify></vue-snotify>

        </v-content>

        <router-view name="footer"></router-view>

        <shortcut></shortcut>

    </v-app>

</template>

<script>
import Snackbar from "@/components/Reusable/Snackbar.vue";
import shortcut from "@/components/Contact/ContactShortcut.vue";
import Api from "@/api";

export default {
    name: 'App',
    data() {
        return {
            //Page name
            viewTitle: "",
            titles: {
                home: "Home",
                Changepassowrd: "Change Password",
                History: "History",
                Promotion: "Promotion",
                Affiliate: "Affiliate",
                Game: "Game",
                Deposit: "Deposit",
                Transfer: "Transfer",
                Banklist: "Withdraw",
                Addbank: "Add Bank Detail",
                login: 'Login'
            },
            showsnackbar: false,
            appmessage: "",
            appicon: "",
            appcolor: ""
        }
    },
    components: {
        Snackbar,
        shortcut
    },
    methods: {
        showToast() {

            this.appmessage = this.$t( 'home.welcome_message', { username: this.$store.getters.user_fullname}) ;

            this.appcolor = "green";

            this.appicon = "done_all";

            this.showsnackbar = true;

        },
        resetToast() {

            this.showsnackbar = false;

        },
        checkToken(token){

            this.$store.dispatch('setToken', token);

        },
        async getMemberInfo(){

            let res = await Api.getMemberInfo({
                access_token: this.$store.getters.user_token
            });

            if (res && 'success' in res && res.success === true) {

                this.$store.dispatch('setMemberInfo', res.data);

                this.$forceUpdate();

                this.showToast();

            } else {

                this.visibility = true;

                this.alertMessage = res.message;

                this.alertType = "error";

                if(res.message == "token invalid") {

                    this.$store.dispatch('logout', res.data);

                    this.$router.push({name: 'login'})

                }

            }
        },
        async postFcmToken(){

            let res = null;

            if (this.$store.getters.user_token !== '') {

                res = await Api.postFcmTokenForUser({
                    access_token: this.$store.getters.user_token,
                    frontend_url: window.location.host,
                    token: this.$store.getters.browser_identity
                });

            } else {

                res = await Api.postFcmTokenForVisitor({
                    token: this.$store.getters.browser_identity,
                    frontend_url: window.location.host,
                });

            }

            if (res && 'success' in res && res.success === true) {

                //console.log(res.message);

            }
        },
        async deleteFcmToken(){

            let res = null;
            //console.log('delete', this.$store.getters.browser_identity);

            if (this.$store.getters.user_token !== '') {

                res = await Api.deleteFcmTokenForUser({
                    access_token: this.$store.getters.user_token,
                    frontend_url: window.location.host,
                    token: this.$store.getters.browser_identity
                });

            } else {

                res = await Api.deleteFcmTokenForVisitor({
                    token: this.$store.getters.browser_identity,
                    frontend_url: window.location.host,
                });

            }

            if (res && 'success' in res && res.success === true) {

                //console.log(res.message);

            }
        },
        handlePermission() {

            return navigator.permissions
                    .query({name:'notifications'})
                    .then(this.permissionQuery);

        },
        permissionQuery(result) {

            var newPrompt;

            if (result.state == 'prompt') {

                let currentInstance = this;

                this.$snotify.confirm(currentInstance.$t( 'fcm.notification_request_message'), currentInstance.$t('fcm.notification'), {
                    position: 'centerTop',
                    buttons: [
                        {text: currentInstance.$t('shared.enable'), action: (toast) => {
                                this.$snotify.remove(toast.id);
                                Notification.requestPermission()
                                .then(function() {
                                    currentInstance.getFCMToken();
                                 });

                            }, bold: false},
                        {text: currentInstance.$t('shared.close'), action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }, bold: false},
                    ]
                });

            } else if (result.state == 'granted') {

                this.getFCMToken();

            } else if (result.state == 'denied') {

                this.$snotify.warning(this.$t('fcm.notification_warning_message'), this.$t('shared.warning'), {
                    timeout: 10000,
                    showProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }

            return newPrompt || result;
        },
        getFCMToken() {

            let currentInstance = this;

            firebase.messaging().getToken()
                .then((token) => {

                    //console.log(currentInstance.$store.getters.browser_identity);
                    //console.log(token);

                    if ( currentInstance.$store.getters.browser_identity !== "" ) {

                        if ( currentInstance.$store.getters.browser_identity !== token) {

                            currentInstance.deleteFcmToken();

                            currentInstance.$store.dispatch('setBrowserIdentify', token);

                            currentInstance.postFcmToken();

                        } else {

                            currentInstance.postFcmToken();

                        }

                    } else {

                        currentInstance.$store.dispatch('setBrowserIdentify', token);

                        currentInstance.postFcmToken();

                    }
                })
                .catch(function(err) {
                    //console.log("Unable to get permission to notify.", err);
                });
        }
    },
    watch: {
        $route(nextVal) {

            this.resetToast();

            if (this.$store.getters.login_flag == true) {

                this.$store.dispatch('toggleLogin', false);

                this.showToast();

            }
            if (nextVal.name || nextVal != "") {

                this.viewTitle = this.titles[nextVal.name];

            } else {

                this.viewTitle = this.titles[this.$route.name];

            }

        }
    },
    mounted: async function() {

        document.querySelector('#pwa-manifest').setAttribute('href', window.api + '/pwa_config');

        if (this.$route.query.t) {

            this.checkToken(this.$route.query.t);

        }

        if (this.$store.getters.user_token !== '') {

            this.getMemberInfo();

        }

        let currencyData = await Api.getCurrency();

        if ( currencyData ) {

             this.$store.dispatch('setSystemCurrency', currencyData.data[0].symbol);

        }

        let resAsset = await Api.getCommonAsset();

        if (resAsset && resAsset['data']) {

            // favicon
            if(resAsset['data']['favicon']) {

                var link = document.querySelector("link[rel*='icon']") || document.createElement('link');

                link.type = 'image/x-icon';

                link.rel = 'shortcut icon';

                link.href = resAsset['data']['favicon']['value'];

                // append child doesnt insert new element in this case, we use this function to move existing favicon to a new position
                document.getElementsByTagName('head')[0].appendChild(link);

            }

            // logo
            if(resAsset['data']['logo']) {

                this.$store.dispatch('setLogo', resAsset['data']['logo']['value']);

            }

            // shortcut contact
            if(resAsset['data']['shorcutContact']) {

                this.$store.dispatch('setContactUs', {
                    'avatar': '',
                    'name': resAsset['data']['shorcutContact']['name'],
                    'contact': resAsset['data']['shorcutContact']['contact'],
                    'type': resAsset['data']['shorcutContact']['type'].toLowerCase(),
                    'contentType': resAsset['data']['shorcutContact']['content_type'].toLowerCase(),
                    'script': resAsset['data']['shorcutContact']['value']
                });

            }

            // background
            if(resAsset['data']['background']) {

                let el = document.getElementById("app");

                el.style.background = "url(" + resAsset['data']['background']['value'] +  ")";

                el.style.backgroundSize = "cover";

                el.style.backgroundPosition = "center";

            }

            // custom script
            if(resAsset['data']['script']) {

                if(resAsset['data']['script']['type'] == 'Editor') {

                     $(resAsset['data']['script']['value']).appendTo(document.body);

                }

            }

        }
        // display toast box
        if (this.$store.getters.login_flag == true) {

            this.$store.dispatch('toggleLogin', false);

            this.showToast();

        }

        let res = await Api.getLivechat();

        if (res) {

            $(res['value']).appendTo(document.body);

        }

        let resCompanyName = await Api.getCompanyName();

        if (resCompanyName && resCompanyName.hasOwnProperty('success') && resCompanyName.success !== true) {

            this.$store.dispatch('setCompanyName', 'Webot');

        } else {

            this.$store.dispatch('setCompanyName', resCompanyName);

            document.title = this.$store.getters.system_name;

            document.body.classList.add(this.$store.getters.system_name.toLowerCase());

        }

        let availableServices = await Api.getAvailableServices();

        if(availableServices && availableServices.success) {

            this.$store.dispatch('setAvailableServices', availableServices.data);

        }

    },
    created: async function() {

        let currentInstance = this;

        //get broswer unique token
        var firebaseConfig = await Api.getFCMConfig();

        firebase.initializeApp(firebaseConfig.data);

        const messaging = firebase.messaging();

        navigator.serviceWorker.register( 'firebase-messaging-sw.js?messagingSenderId=' + firebaseConfig.data["messagingSenderId"] )
        .then( function( registration ) {

            messaging.useServiceWorker( registration );

        }).then( function() {

            //currentInstance.$store.dispatch('setBrowserIdentify', '');

            currentInstance.handlePermission();

            messaging.onMessage(function(payload) {
                //console.log("Message received. ", payload);
            });

        });
    }
}
</script>

<style>

    .v-avatar img {
        object-fit: contain !important;
    }

    .transparent-bg {
        background-color: rgba(0,0,0,0) !important;
    }
    .semi-transparent-bg {
        background-color: rgba(0,0,0,0.38) !important;
    }

    .semi-transparent-5-bg , .v-datatable.v-table ,.v-datatable.v-table .v-datatable__actions {
        background-color: rgba(0,0,0,0.54) !important;
    }

    .semi-transparent-7-bg {
        background-color: rgba(0,0,0,0.7) !important;
    }

    .semi-transparent-8-bg {
        background-color: rgba(0,0,0,0.8) !important;
    }

    .semi-transparent-9-bg {
        background-color: rgba(0,0,0,0.9) !important;
    }

    .semi-transparent-light-effect-game-card {
        border: 2px solid rgba(0, 0, 0, 0.38)!important;
        border-radius: 10px !important;
        background: -moz-radial-gradient(bottom center, ellipse cover, rgba(255, 255, 255, 0.8) 15%,rgba(0,0,0,0) 80%)!important;
        background: -webkit-radial-gradient(bottom center, ellipse cover, rgba(255, 255, 255, 0.8) 15%,rgba(0,0,0,0) 80%)!important;
        background: radial-gradient(ellipse at bottom center, rgba(255, 255, 255, 0.8) 15%,rgba(0,0,0,0) 80%)!important;
    }

    .semi-transparent-light-effect-game-carousel {
        color: #f8f8ff;
        /* border: 2px solid rgb(207,181,59, 0.6); */
        box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.5);
        background-color: rgba(0,0,0,0.4);
        border-radius: 10px !important;
    }

    .product-carousel {
        border: 1px solid rgba(166, 166, 166, 0.2);
        padding-top: 7px !important;
        padding-bottom: 7px !important;
        background-color: rgba(0,0,0,0.4);
    }

    /* .home-carousel {
        border-left: 1px solid rgba(166, 166, 166, 0.37);
        border-right: 1px solid rgba(166, 166, 166, 0.37);
    } */

    .rounded-border {
        border: 2px solid rgba(0, 0, 0, 0.38);
        border-radius: 3px !important;
    }

    .menu-container {
        /* padding-left: 15px !important;
        padding-right: 15px !important; */
        display: flex;
    }

    .v-datatable__actions {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        font-size: 12px;
        -ms-flex-wrap: wrap-reverse;
        flex-wrap: wrap-reverse;
    }

    .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s
    }

    .fade-enter, .fade-leave-active {
    opacity: 0
    }

    .margin-5-top-bottom {
        margin-top: 5px;
        margin-bottom: 5px;
    }

    .margin-16-right{
        margin-right: 16px;
    }

    #app .snotify .snotify-confirm {
        background-color: rgb(2 18 30 / 90%);
    }

</style>

